export default from './Text';



// WEBPACK FOOTER //
// ./src/components/atoms/Text/index.js